import React, { useState } from "react"
import VisibilitySensor from "react-visibility-sensor"
import PropTypes from "prop-types"
import Link from "../components/Link"

const CaseItem = ({ node }) => {
  const [colorState, setColorState] = useState("dark")
  const onChange = isVisible => {
    isVisible || colorState === "was-in-view"
      ? setColorState("was-in-view")
      : setColorState("dark")
  }
  let image = null
  if (node.heroImage !== null) {
    image = node.heroImage.gatsbyImageData.images.fallback.src
  }

  return (
    <VisibilitySensor onChange={onChange} partialVisibility>
      <Link
        to={`/cases/${node.slug}/`}
        className={`case-card slide-in ${colorState}`}
      >
        <div className="case-card-title">
          <h4>{node.title}</h4>
          <div className="case-sub-header">
            {node.department && (
              <div className="case-sub-header-item">
                <div>
                  <div className="label">Afdeling: </div>
                  {node.department.name}
                </div>
              </div>
            )}
            {node.institution && (
              <div className="case-sub-header-item">
                <div>
                  <div className="label">Enhed: </div>
                  {node.institution.name}
                </div>
              </div>
            )}
            {node.institution.region && (
              <div className="case-sub-header-item">
                <div>
                  <div className="label">Organisation: </div>
                  {node.institution.region.name}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="case-grid-col">
          <div className="case-grid-image">
            {node.heroImage && (
              <img
                src={image}
                className="case-featured-image"
                alt={node.heroImage.title}
              />
            )}
          </div>
        </div>
      </Link>
    </VisibilitySensor>
  )
}

CaseItem.propTypes = {
  node: PropTypes.object,
}

CaseItem.defaultProps = {
  node: null,
}

export default CaseItem
